module Shared.Admin.Tags.StronglyTypedIds
open System

type TagId = TagId of Guid
module TagId = 
    let unwrap (TagId x) = x